import Vuex from "vuex";
import basicNode from '@/images/basic_node.svg'
import advancedNode from '@/images/advanced_node.svg'
export default new Vuex.Store({
	state: {
		connectedWallet: '',
		connectedChainId: null,
		referrerWalletAddress: null,
		referLink: null,
		myNfts: [],
		nodeList: [
			{
				code: 'BASIC_NODE',
				type: 'basic',
				name: '初级节点',
				nameEn: 'Basic Node',
				price: '1000',
				iconSvg: basicNode,
				des:[
					'獲得全網NFT新增業績2.5%分紅',
					'获得4倍代币燃料值',
					'获得娱乐游戏平台收益的5%分红',
					'获得每日产出FAC代币2%分配',
					'獲得算力挖礦'
				],
				btnTxt: '购买初级节点'
			},
			{
				code: 'ADVANCED_NODE',
				type: 'advanced',
				name: '高级节点',
				nameEn: 'Advanced Node',
				price: '3000',
				iconSvg: advancedNode,
				des:[
					'獲得全網NFT新增業績2.5%分紅',
					'获得5倍代币燃料值',
					'获得娱乐游戏平台收益的5%分红',
					'获得每日产出FAC代币2%分配',
					'獲得算力挖礦',
					'獲得DAO投票權限'
				],
				btnTxt: '购买高级节点'
			}
		],
		myNftList: [],
		referId: null
	},
	mutations: {
		SET_CONNECTED_ACCOUNT(state, payload) {
			state.connectedWallet = payload.wallet
			state.connectedChainId = payload.chainId
		},
		SET_REFER_LINK(state, payload) {
			state.referLink = payload.referLink
		},
		SET_REFERRER_WALLET_ADDRESS(state, payload) {
			state.referrerWalletAddress = payload.referrerWalletAddress
		},
		SET_REFER_ID(state, payload) {
			state.referId = payload.referId
		},
		SET_MY_NFTS(state, payload) {
			state.myNfts = payload.myNfts
		},
		SET_MY_NFT_LIST(state, payload) {
			state.myNftList = payload.nftList
		}
	},
	actions: {
		setConnectedAccount({commit}, payload) {
			commit('SET_CONNECTED_ACCOUNT', payload);
		},
		setReferLink({commit}, payload) {
			commit('SET_REFER_LINK', payload);
		},
		setReferrerWalletAddress({commit}, payload) {
			commit('SET_REFERRER_WALLET_ADDRESS', payload);
		},
		setReferId({commit}, payload) {
			commit('SET_REFER_ID', payload);
		},
		setMyNFTs({commit}, payload) {
			commit('SET_MY_NFTS', payload);
		},
		setMyNFTList({commit}, payload) {
			commit('SET_MY_NFT_LIST', payload);
		}
	}
});